import NoResults from 'components/general/noResults';
import { taskRating } from 'components/tasks/taskList';
import { ArrayHelpers, Help, Loading, SystemText } from 'e4shared';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { apiGet } from 'services';
import TaskIcon from 'views/user/task/components/taskIcon';
import { e4Format, differenceInCalendarDays } from 'helpers/dates';

export const Tasks = ({ profileId, range, offset, filter }) => {
    const [tasks, setTasks] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    const { user } = useSelector(state => state.user);

    React.useEffect(() => {
        setLoading(true);
        apiGet(`profile/${profileId}/tasks?filter=${filter}&offset=${offset}&range=${range}`, user.guid, response => {
            setTasks(response.tasks);
            setLoading(false);
        });
    }, [profileId, range, offset, filter]);

    if (loading) return <Loading />;

    return (
        <div>
            {ArrayHelpers.existsAndHasLength(tasks) ? (
                tasks.map(task => {
                    const diff = task.date_Completed ? differenceInCalendarDays(task.due, task.date_Completed) : 0;
                    return (
                        <div className="mb10" key={`task-${task.id}`}>
                            <div>
                                <Link to={`/objectives/${task.profile_Id}/objective/${task.id}`}>
                                    {task.name}
                                    <TaskIcon icons={task.icons} />
                                    {task.description && <Help id={`row_${task.id}`}>{task.description}</Help>}
                                </Link>
                            </div>
                            <div>
                                {SystemText('Tasks/TaskList/Summary/Completed')} {e4Format(task.date_Completed)}
                            </div>
                            <div className="mt5">
                                <span className="flex flex-center">
                                    {task.metric_Task && !task.goal_Met ? (
                                        <div className="p5 ml10 hidden-xs hidden-sm hidden-md label label-danger">
                                            <i className="fa fa-times fa-red mr5" />
                                            <span>{SystemText('Tasks/TaskList/Summary/NotAchieved')}</span>
                                        </div>
                                    ) : diff < 0 ? (
                                        <div className="p5 hidden-xs hidden-sm hidden-md label label-danger">
                                            <i className="fa fa-warning fa-red mr5" />
                                            <span>{SystemText('Tasks/TaskList/Summary/Late')}</span>
                                        </div>
                                    ) : (
                                        <div className="p5 hidden-xs hidden-sm hidden-md label label-success">
                                            <i className="fa fa-thumbs-up fa-green mr5" />
                                            <span>{SystemText('Tasks/TaskList/Summary/OnTime')}</span>
                                        </div>
                                    )}
                                </span>
                            </div>
                            <div className="mt5">{taskRating(task, null, true)}</div>
                        </div>
                    );
                })
            ) : (
                <NoResults
                    title={SystemText('Tasks/TaskList/Summary/NoResults/Title')}
                    message={SystemText('Tasks/TaskList/Summary/NoResults/Message')}
                />
            )}
        </div>
    );
};

export default Tasks;
